import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import Product from "./pages/Product";
import ProductModules from "./pages/ProductModules";
import Solutions from "./pages/Solutions";
import SolutionDetail from "./pages/SolutionDetail";
import Features from "./pages/Features";
import HowItWorks from "./pages/HowItWorks";
import Benefits from "./pages/Benefits";
import BenefitsImpact from "./pages/BenefitsImpact";
import Resources from "./pages/Resources";
import ResourceDetail from "./pages/ResourceDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import ScrollToTopButton from "./components/ScrollToTopButton";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTopButton />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />

          <Route path="/product" element={<Product />} />
          <Route path="/product/modules" element={<ProductModules />} />

          <Route path="/solutions" element={<Solutions />} />
          <Route path="/solutions/:slug" element={<SolutionDetail />} />

          <Route path="/features" element={<Features />} />
          <Route path="/features/how-it-works" element={<HowItWorks />} />

          <Route path="/benefits" element={<Benefits />} />
          <Route path="/benefits/impact" element={<BenefitsImpact />} />

          <Route path="/resources" element={<Resources />} />
          <Route path="/resources/:slug" element={<ResourceDetail />} />

          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
